import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { useMount } from "react-use";
import { useStores } from "../hooks";
import { getLockerInfo } from "../service";
import Slider from "react-slick";
import Header from "../component/Header";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./slick/slick.css";
import "./slick/slick-theme.css";
import "./slick.css";

var settings = {
  dots: true,
  fade: true,
  arrows: true,
  accessibility: true,
  autoplay: true,
  autoplaySpeed: 5000,
  className: "center",
  centerMode: true,
  infinite: true,
  swipeToSlide: true,
  centerPadding: "20px",
  slidesToShow: 1,
  speed: 1000,
  rows: 5,
  slidesPerRow: 5,
};

const Main = () => {
  const { formatMessage } = useIntl();
  const { sessionStore } = useStores();
  const [complete, setComplate] = useState(false);

  useMount(() => {
    handleLockerData();
  });

  const handleLockerData = () => {
    getLockerInfo()
      .then((res) => {
        sessionStore.setLocker(
          res.locker_detail,
          res.locker.locker_tier,
          res.locker.locker_column,
          res.items
        );
      })
      .finally(() => {
        setComplate(true);
      });
  };

  return (
    <>
      {complete && (
        <div className="index-set">
          <Header />
          <div className="Main">
            <Slider {...settings}>
              {sessionStore.items && sessionStore.items.map((item, i) => {
                return (
                  <div key={"book-" + item.id}>
                    <Link className="order" to={"/book?id=" + item.id}>
                      <img alt={item.title} src={item.photo} />
                    </Link>
                  </div>
                );
              })}
            </Slider>
            {sessionStore.items &&sessionStore.items.length === 0 && (
              <div className="soldout">
                <p>
                  {formatMessage(
                    { id: "hyvendor.soldout" },
                    {
                      br: <br />,
                    }
                  )}
                </p>
              </div>
            )}
            <p>&nbsp;</p>
            <section className="Menu">
              <Link className="order" to="/login" state={{ from: "/book" }}>
                {formatMessage({ id: "hyvendor.button.lend" })}
              </Link>
            </section>
          </div>
        </div>
      )}
      ;
    </>
  );
};

export default Main;
